/* eslint-disable import/prefer-default-export */
import {
  CompletionCheckResponse,
  FormWeeklyLogInterface,
  WeeklyLogReqResponse,
  WeeklyLogResponse,
} from '../pages/WeeklyLog/WeeklyLogModel';
import APIClient from '../services/APIClient';

export const fetchWeeklyLogs = async (
  start_date?: string,
  end_date?: string,
  owner?: string,
  prev_week?: number,
) => {
  const clientAPI = new APIClient();
  const params: string[] = [];

  if (start_date) params.push(`start_date=${start_date}`);
  if (end_date) params.push(`end_date=${end_date}`);
  if (owner) params.push(`owner=${owner}`);
  if (prev_week) params.push(`prev_week=${prev_week}`);

  let endpoint = `/users-weekly-logs/weekly-report/`;

  if (params.length > 0) endpoint += `?${params.join('&')}`;

  const weeklyLogs = await clientAPI.client.get<WeeklyLogReqResponse>(endpoint);
  return weeklyLogs.data;
};

export const exportWeeklyLogs = async (
  start_date?: string,
  end_date?: string,
  owner?: string,
  prev_week?: number,
) => {
  const clientAPI = new APIClient();
  const params: string[] = [];

  if (start_date) params.push(`start_date=${start_date}`);
  if (end_date) params.push(`end_date=${end_date}`);
  if (owner) params.push(`owner=${owner}`);
  if (prev_week) params.push(`prev_week=${prev_week}`);

  let endpoint = `/v2/export-scheduler/?approach=weekly_logs`;

  if (params.length > 0) endpoint += `&${params.join('&')}`;

  const weeklyLogs = await clientAPI.client.get<string>(endpoint);
  return weeklyLogs.data;
};

export const postWeeklyFormLog = async (objects: FormWeeklyLogInterface[]) => {
  const clientAPI = new APIClient();

  const endpoint = '/users-weekly-logs/save-records/';

  const weeklyLogs = await clientAPI.client.post<WeeklyLogResponse[]>(
    endpoint,
    objects,
  );
  return weeklyLogs.data;
};

export const weekCompletion = async (
  start_date?: string,
  end_date?: string,
) => {
  const clientAPI = new APIClient();

  const endpoint = `/users-weekly-logs/check-completion/?start_date=${start_date}&end_date=${end_date}`;

  const completion = await clientAPI.client.get<CompletionCheckResponse>(
    endpoint,
  );
  return completion.data;
};
